<template>
  <v-app>
    <v-snackbar v-model="snackbar">
      {{ msg }}
      <v-btn dark text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
    <v-container grid-list-lg>
      <v-row class="justify-center align-center">
        <v-col class="col-12 col-md-6">
          <div class="align-center d-flex mb-3">
            <v-icon color="primary" size="32" class="justify-end mr-2">live_help</v-icon>
            <h2 class="justify-start primary--text">
              Ajuda e Suporte
            </h2>
          </div>
          <v-row class="flex-column mx-5 fill-height">
            <p class="subtitle-1">Mensagem:</p>
            <v-textarea
              solo
              flat
              filled
              no-resize
              rows="12"
              placeholder="Digite aqui sua mensagem..."
              v-model="msgHelp"
            >
            </v-textarea>
          </v-row>
          <div class="layout column align-center">
            <v-btn large color="secondary" class="mb-4" @click="sendMsg()" :loading="isLoading">
              <v-icon class="mr-2">send</v-icon>
              ENVIAR
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import HelpService from '../services/general';

export default {
  data() {
    return {
      msgHelp: '',
      snackbar: false,
      msg: '',
      isLoading: false,
    };
  },
  methods: {
    async sendMsg() {
      try {
        this.isLoading = true;
        const category = localStorage.getItem('user-category');
        const user = await JSON.parse(localStorage.getItem('user-data'));
        const response = await HelpService.sendHelp(user.name, user.email, category, this.msgHelp);
        if (response.status === 204) {
          this.snackbar = true;
          this.msg = 'Mensagem envida com sucesso!';
          this.msgHelp = '';
        } else {
          this.snackbar = true;
          this.msg = 'Ocorreu um erro, tente novamente!';
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
